import { render, staticRenderFns } from "./Formulario.vue?vue&type=template&id=22becad8&scoped=true"
import script from "./Formulario.vue?vue&type=script&lang=js"
export * from "./Formulario.vue?vue&type=script&lang=js"
import style0 from "./Formulario.vue?vue&type=style&index=0&id=22becad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22becad8",
  null
  
)

export default component.exports